export default "__VITE_ASSET__b094ef68__"